import { StringMap } from '@types';

export const modulesQuill: StringMap = {
  toolbar: {
    container: [
      [
        'bold',
        'underline',
        'link',
        { list: 'bullet' },
        { indent: '+1' },
        { indent: '-1' },
        {
          color: ['primary', '#FF6A47'],
        },
      ],
    ],
    handlers: {
      color: function (value) {
        if (value == 'primary') value = null;
        this.quill.format('color', value, 'user');
      },
    },
  },
};

export const formatsQuill: string[] = [
  'bold',
  'strike',
  'underline',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'color',
  'padding',
];
